(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/components/play/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/components/play/assets/javascripts/prescript.js');

'use strict';

svs.vikinglotto = svs.vikinglotto || {};
svs.vikinglotto.components = svs.vikinglotto.components || {};
svs.vikinglotto.components.play = svs.vikinglotto.components.play || {};
svs.vikinglotto.components.play.views = svs.vikinglotto.components.play.views || {};

 })(window);